module.exports = __webpack_public_path__ + "img/icon-42.74a12348.svg";